import React from 'react'
import { useNavigate, useLocation } from "react-router-dom";
import CommonNavbar from '../../Navbar/CommonNavbar';
import { usePermissions } from '../../hooks/PermissionContext';
import PermissionWrapper from '../../hooks/PermissionWrapper';

const Masters_header = ({ onSearch, disableSearch = false }) => {

  const { getModulePermission } = usePermissions();


  // Define module IDs
  const chargecodemoduleId = 1;
  const jobtypemoduleId = 2;
  const rolemastermoduleId = 3;
  const usermastermoduleId = 4;
  const designationmastermoduleId = 5;
  const vendormastermoduleId = 6;
  const plantcodemastermoduleId = 30;

  // Fetch permissions per module
  const chargecodePermission = getModulePermission(chargecodemoduleId);
  const jobtypePermission = getModulePermission(jobtypemoduleId);
  const rolemasterPermission = getModulePermission(rolemastermoduleId);
  const usermasterPermission = getModulePermission(usermastermoduleId);
  const designationPermission = getModulePermission(designationmastermoduleId);
  const vendorPermission = getModulePermission(vendormastermoduleId);
  const plantcodePermission = getModulePermission(plantcodemastermoduleId);

  // Debug logs
  console.log("Charge Code Permission:", chargecodePermission);
  console.log("Job Type Permission:", jobtypePermission);
  console.log("Role Master Permission:", rolemasterPermission);
  console.log("User Master Permission:", usermasterPermission);
  console.log("Designation Permission:", designationPermission);
  console.log("Vendor Permission:", vendorPermission);
  console.log("Plant Code Permission:", plantcodePermission);



  const navigate = useNavigate();
  const location = useLocation(); // Get current URL path

  const handleNavigation = (path) => {
    navigate(path); // Navigate to the new page
  };
  return (
    <div>
      <header>
        <nav className="nav-items">
          <ul className="nav-links">

            <PermissionWrapper permissionKey="menu_permission" moduleId={chargecodemoduleId}>
              <li className="list">
                <button
                  onClick={() => handleNavigation("/chargecode")}
                  className={`tabs ${location.pathname === "/chargecode" ? "active" : ""}`}
                >
                  Charge code
                </button>
              </li>
            </PermissionWrapper>


            <PermissionWrapper permissionKey="menu_permission" moduleId={jobtypemoduleId}>
              <li className="list">
                <button
                  onClick={() => handleNavigation("/jobtype")}
                  className={`tabs ${location.pathname === "/jobtype" ? "active" : ""}`}
                >
                  Job type
                </button>
              </li>
            </PermissionWrapper>

            <PermissionWrapper permissionKey="menu_permission" moduleId={rolemastermoduleId}>
              <li className="list">
                <button
                  onClick={() => handleNavigation("/roleMaster")}
                  className={`tabs ${location.pathname.startsWith("/role") ? "active" : ""}`}
                >
                  Role Master
                </button>
              </li>
            </PermissionWrapper>


            <PermissionWrapper permissionKey="menu_permission" moduleId={usermastermoduleId}>
              <li className="list">
                <button
                  onClick={() => handleNavigation("/user")}
                  className={`tabs ${location.pathname.startsWith("/user") ? "active" : ""}`}
                >
                  User
                </button>
              </li>
            </PermissionWrapper>

            <PermissionWrapper permissionKey="menu_permission" moduleId={designationmastermoduleId}>
              <li className="list">
                <button
                  onClick={() => handleNavigation("/designation")}
                  className={`tabs ${location.pathname.startsWith("/designation") ? "active" : ""}`}
                >
                  Designation
                </button>
              </li>
            </PermissionWrapper>

            <PermissionWrapper permissionKey="menu_permission" moduleId={plantcodemastermoduleId}>
              <li className="list">
                <button
                  onClick={() => handleNavigation("/plantCode")}
                  className={`tabs ${location.pathname.startsWith("/plantCode") ? "active" : ""}`}
                >
                  Plant Code
                </button>
              </li>
            </PermissionWrapper>

            <PermissionWrapper permissionKey="menu_permission" moduleId={vendormastermoduleId}>
              <li className="list">
                <button
                  onClick={() => handleNavigation("/vendor")}
                  className={`tabs ${location.pathname.startsWith("/vendor") ? "active" : ""}`}
                >
                  Vendor
                </button>
              </li>
            </PermissionWrapper>

          </ul>

          <CommonNavbar onSearch={onSearch} disableSearch={disableSearch} />
        </nav>
      </header>
    </div>
  )
}

export default Masters_header